import {useEffect, useState} from "react";
import {getTrackBackground, Range} from "react-range";
import {useSelector} from "react-redux";
import {css, Theme, useTheme} from "@emotion/react";
import styled from "@emotion/styled";

import {calculateRemSize, flex, flexDirection, mt, pv} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";
import {form, IFormProps} from "@pg-mono/form";
import {pluralize, priceFormat} from "@pg-mono/string-utils";

import {IRPStore} from "../../app/rp_reducer";
import {useGetStatsQuery} from "../api/configurator_api";
import {useRegionPriceSliderValues} from "../hooks/use_region_price_slider_values";
import {useRegionsIds} from "../hooks/use_regions_ids";
import {ISearchFiltersFormValues} from "../reducers/property_configurator_reducer";
interface IProps extends IFormProps<ISearchFiltersFormValues> {}

export const BudgetSliderC = (props: IProps) => {
    const propertiesCount = useSelector((store: IRPStore) => store.propertyConfigurator.propertiesCount);
    const priceProps = props.getFieldProps("price");
    const {regionsIds} = useRegionsIds();
    const {data} = useGetStatsQuery({regionsIds: regionsIds || []}, {skip: !regionsIds});
    const {range, min, max, step, nearestMin} = useRegionPriceSliderValues(data?.maxPrice);
    const offersPluralized = pluralize(["oferta", "oferty", "ofert"]);

    const maxPropertiesCount = Math.max(...range);
    const maxPropertiesCountIndex = range.indexOf(maxPropertiesCount);

    const [values, setValues] = useState([0]);
    const theme = useTheme();

    useEffect(() => {
        const newValue = nearestMin + step * (maxPropertiesCountIndex + 1);
        if (!min) {
            return;
        }

        if (min < max && min <= values[0] && max >= values[0]) {
            return;
        }

        setValues([newValue]);
        priceProps.onChange("price", {
            lower: "",
            upper: newValue.toString()
        });
    }, [min, range]);

    if (min >= max || values[0] < min || values[0] > max) {
        return <></>;
    }

    return (
        <div css={wrapper}>
            <div css={barWrapper}>
                {range.map((value, index) => {
                    return <Bar height={(value / maxPropertiesCount) * 100} key={index} />;
                })}
            </div>
            <Range
                onFinalChange={(newValues) => {
                    priceProps.onChange("price", {
                        lower: "",
                        upper: newValues[0] === max ? "" : newValues[0].toString()
                    });
                }}
                onChange={setValues}
                values={values}
                step={step}
                min={nearestMin}
                max={max}
                renderTrack={({props, children}) => (
                    <div onMouseDown={props.onMouseDown} onTouchStart={props.onTouchStart} css={[{...props.style}, trackWrapper]}>
                        <TrackContainer ref={props.ref} values={values} min={nearestMin} max={max}>
                            {children}
                        </TrackContainer>
                    </div>
                )}
                renderThumb={({props}) => <div {...props} css={[{...props.style}, thumbStyle]}></div>}
            />
            <Text variant="headline_6" css={mt(2)}>
                {`do ${priceFormat(values[0])}`}
            </Text>
            <Text variant="body_copy_2" color={theme.colors.gray[700]}>
                {!!propertiesCount && `${propertiesCount} ${offersPluralized(propertiesCount)}`}
            </Text>
        </div>
    );
};

export const BudgetSlider = form<ISearchFiltersFormValues, IProps>(BudgetSliderC);

const trackWrapper = css`
    width: 100%;
    flex-grow: 1;
    display: flex;
`;

interface TrackContainerProps {
    values: number[];
    min: number;
    max: number;
}
const TrackContainer = styled.div<TrackContainerProps>`
    width: 100%;
    height: 16px;
    border-radius: 100px;
    border: 1px solid ${({theme}) => theme.colors.secondary};
    align-self: center;
    background: ${({values, theme, min, max}) =>
        getTrackBackground({
            values,
            colors: [theme.colors.primary, "#E1D7CD"],
            min,
            max
        })};

    @media (min-width: ${({theme}) => theme.breakpoints.md}) {
        height: 23px;
    }
`;

const thumbStyle = (theme: Theme) => css`
    height: ${calculateRemSize(4)};
    width: ${calculateRemSize(4)};
    background-color: ${theme.colors.primary};
    border: 2px solid #23232d;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50px;
    outline: none;

    @media (min-width: ${theme.breakpoints.md}) {
        height: ${calculateRemSize(5)};
        width: ${calculateRemSize(5)};
    }
`;

interface BarProps {
    height: number;
}

const barWrapper = css`
    width: 100%;
    ${flex("flex-end")};
    height: 200px;
`;

const Bar = styled.div<BarProps>`
    height: ${({height}) => height}%;
    width: 100%;
    display: block;
    background-color: ${({theme}) => theme.colors.success};
    opacity: 0.8;
    &:nth-of-type(2n) {
        opacity: 1;
    }
`;

const wrapper = css`
    width: 100%;
    ${pv(3)};
    ${flex("center")};
    ${flexDirection("column")};
`;
import {useEffect, useState} from "react";
import {getTrackBackground, Range} from "react-range";
import {useSelector} from "react-redux";
import {css, Theme, useTheme} from "@emotion/react";
import styled from "@emotion/styled";

import {calculateRemSize, flex, flexDirection, mt, pv} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";
import {form, IFormProps} from "@pg-mono/form";
import {pluralize, priceFormat} from "@pg-mono/string-utils";

import {IRPStore} from "../../app/rp_reducer";
import {useGetStatsQuery} from "../api/configurator_api";
import {useRegionPriceSliderValues} from "../hooks/use_region_price_slider_values";
import {useRegionsIds} from "../hooks/use_regions_ids";
import {ISearchFiltersFormValues} from "../reducers/property_configurator_reducer";
interface IProps extends IFormProps<ISearchFiltersFormValues> {}

export const BudgetSliderC = (props: IProps) => {
    const propertiesCount = useSelector((store: IRPStore) => store.propertyConfigurator.propertiesCount);
    const priceProps = props.getFieldProps("price");
    const {regionsIds} = useRegionsIds();
    const {data} = useGetStatsQuery({regionsIds: regionsIds || []}, {skip: !regionsIds});
    const {range, min, max, step, nearestMin} = useRegionPriceSliderValues(data?.maxPrice);
    const offersPluralized = pluralize(["oferta", "oferty", "ofert"]);

    const maxPropertiesCount = Math.max(...range);
    const maxPropertiesCountIndex = range.indexOf(maxPropertiesCount);

    const [values, setValues] = useState([0]);
    const theme = useTheme();

    useEffect(() => {
        const newValue = nearestMin + step * (maxPropertiesCountIndex + 1);
        if (!min) {
            return;
        }

        if (min < max && min <= values[0] && max >= values[0]) {
            return;
        }

        setValues([newValue]);
        priceProps.onChange("price", {
            lower: "",
            upper: newValue.toString()
        });
    }, [min, range]);

    if (min >= max || values[0] < min || values[0] > max) {
        return <></>;
    }

    return (
        <div css={wrapper}>
            <div css={barWrapper}>
                {range.map((value, index) => {
                    return <Bar height={(value / maxPropertiesCount) * 100} key={index} />;
                })}
            </div>
            <Range
                onFinalChange={(newValues) => {
                    priceProps.onChange("price", {
                        lower: "",
                        upper: newValues[0] === max ? "" : newValues[0].toString()
                    });
                }}
                onChange={setValues}
                values={values}
                step={step}
                min={nearestMin}
                max={max}
                renderTrack={({props, children}) => (
                    <div onMouseDown={props.onMouseDown} onTouchStart={props.onTouchStart} css={[{...props.style}, trackWrapper]}>
                        <TrackContainer ref={props.ref} values={values} min={nearestMin} max={max}>
                            {children}
                        </TrackContainer>
                    </div>
                )}
                renderThumb={({props}) => <div {...props} css={[{...props.style}, thumbStyle]}></div>}
            />
            <Text variant="headline_6" css={mt(2)}>
                {`do ${priceFormat(values[0])}`}
            </Text>
            <Text variant="body_copy_2" color={theme.colors.gray[700]}>
                {!!propertiesCount && `${propertiesCount} ${offersPluralized(propertiesCount)}`}
            </Text>
        </div>
    );
};

export const BudgetSlider = form<ISearchFiltersFormValues, IProps>(BudgetSliderC);

const trackWrapper = css`
    width: 100%;
    flex-grow: 1;
    display: flex;
`;

interface TrackContainerProps {
    values: number[];
    min: number;
    max: number;
}
const TrackContainer = styled.div<TrackContainerProps>`
    width: 100%;
    height: 16px;
    border-radius: 100px;
    border: 1px solid ${({theme}) => theme.colors.secondary};
    align-self: center;
    background: ${({values, theme, min, max}) =>
        getTrackBackground({
            values,
            colors: [theme.colors.primary, "#E1D7CD"],
            min,
            max
        })};

    @media (min-width: ${({theme}) => theme.breakpoints.md}) {
        height: 23px;
    }
`;

const thumbStyle = (theme: Theme) => css`
    height: ${calculateRemSize(4)};
    width: ${calculateRemSize(4)};
    background-color: ${theme.colors.primary};
    border: 2px solid #23232d;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50px;
    outline: none;

    @media (min-width: ${theme.breakpoints.md}) {
        height: ${calculateRemSize(5)};
        width: ${calculateRemSize(5)};
    }
`;

interface BarProps {
    height: number;
}

const barWrapper = css`
    width: 100%;
    ${flex("flex-end")};
    height: 200px;
`;

const Bar = styled.div<BarProps>`
    height: ${({height}) => height}%;
    width: 100%;
    display: block;
    background-color: ${({theme}) => theme.colors.success};
    opacity: 0.8;
    &:nth-of-type(2n) {
        opacity: 1;
    }
`;

const wrapper = css`
    width: 100%;
    ${pv(3)};
    ${flex("center")};
    ${flexDirection("column")};
`;
